import { routes } from '../config/api_routes'

export const userService = {
    getUserDetail: () => window.axios.get(routes.userDetailApi),

    userCheckEmail: (formData) => window.axios.post(routes.userCheckEmailApi, formData),
}